<template>
  <div style="margin-bottom: 10px">
    <!-- 自定义配置 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>杂项配置（具体格式由客户端决定）</span>
      </div>
      <div>
        <el-input type="textarea" :rows="10" placeholder="请输入内容（具体格式由客户端决定）" v-model="data.misc">
        </el-input>
      </div>
    </el-card>

    <!-- 各阶段的奖励 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>收集阶段奖励</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditCollectItemsActivityCollectStageDialog(true, null)">新增收集阶段奖励</el-button>
      </div>
      <el-table :data="data.collectStages" border size="small" style="width: 551px; margin-top: 10px">
        <el-table-column prop="range" label="目标进度" align="center" width="100">
          <template scope="scope">
            {{ scope.row.quantity }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="label" label="奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red" @click="removeCollectStage(scope.$index)">删除</span>
            <span class="link-button"
              @click="openEditCollectItemsActivityCollectStageDialog(false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 各排名的奖励 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>排名奖励</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditActivityLeaderboardDialog(true, null)">新增排名奖励</el-button>
      </div>
      <el-table :data="data.leaderboard" border size="small" style="width: 551px; margin-top: 10px">
        <el-table-column prop="range" label="排名区间" align="center" width="100">
          <template scope="scope">
            {{ scope.row.rankingRange[0] == scope.row.rankingRange[1] ? scope.row.rankingRange[0] :
              `${scope.row.rankingRange[0]} - ${scope.row.rankingRange[1]}` }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="label" label="奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red" @click="removeLeaderboardRankingEntry(scope.$index)">删除</span>
            <span class="link-button"
              @click="openEditActivityLeaderboardDialog(false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
export default {
  data() {
    return {
      data: {
        misc: "{}",
        collectStages: [],
        leaderboard: [],
      },
    };
  },
  components: {
    ShowItems,
  },

  props: {
    parameters: "",
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    if (this.parameters) {
      this.data = JSON.parse(this.parameters);
    }
  },

  methods: {
    async openEditCollectItemsActivityCollectStageDialog(isCreated, entry, index) {
      let targetEntry = null;
      if (entry) {
        targetEntry = {
          quantity: entry.quantity,
          rewards: entry.rewards,
        };
      }

      let that = this;
      this.$dialogutil.open("EditCollectItemsActivityCollectStageDialog", {
        closedCallback: async (entry) => {
          console.log("entry:", entry)

          if (entry != null) {
            let localEntry = {
              quantity: entry.quantity,
              rewards: entry.rewards,
            };

            if (isCreated) {
              that.data.collectStages.push(localEntry);
            } else {
              this.$set(that.data.collectStages, index, localEntry);
            }

            this.data.collectStages.sort((x, y) => {
              return x.quantity - y.quantity;
            });

            await this.updatedParam();
          }
        },
        data: { isCreated: isCreated, entry: targetEntry },
      });
    },

    async removeCollectStage(index) {
      try {
        let collectStage = this.data.collectStages[index];

        // 弹确认框
        await this.$confirm(
          `确认删除目标进度为[${collectStage.quantity}]的收集阶段配置？`
        );
        this.data.collectStages.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },

    async openEditActivityLeaderboardDialog(isCreated, entry, index) {
      let targetRankingEntry = null;
      if (entry) {
        targetRankingEntry = {
          rankRange: entry.rankingRange,
          reward: entry.rewards,
        };
      }

      let that = this;
      this.$dialogutil.open("EditActivityLeaderboardDialog", {
        closedCallback: async (rankingEntry) => {
          if (rankingEntry != null) {
            let localRankingEntry = {
              rankingRange: rankingEntry.rankRange,
              rewards: rankingEntry.reward,
            };

            if (isCreated) {
              that.data.leaderboard.push(localRankingEntry);
            } else {
              this.$set(that.data.leaderboard, index, localRankingEntry);
            }

            this.data.leaderboard.sort((x, y) => {
              return x.rankingRange[0] - y.rankingRange[0];
            });

            await this.updatedParam();
          }
        },
        data: { isCreated: isCreated, entry: targetRankingEntry },
      });
    },

    async removeLeaderboardRankingEntry(index) {
      try {
        let rankingEntry = this.data.leaderboard[index];

        // 弹确认框
        await this.$confirm(
          `确认删除排名区间[${rankingEntry.rankingRange}]的排名奖励配置？`
        );
        this.data.leaderboard.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },

    async updatedParam() {
      this.$emit("updated", JSON.stringify(this.data), async () => {
        for (let index = 0; index < this.data.leaderboard.length; index++) {
          if (index == 0) {
            continue;
          }
          let rankingEntry = this.data.leaderboard[index];
          let preRankingEntry = this.data.leaderboard[index - 1];
          if (rankingEntry.rankingRange[0] - preRankingEntry.rankingRange[1] != 1) {
            return { errMsg: "各个排名区之间必须前后衔接" };
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>